import EntityHeader from "./EntityHeader";

export default EntityHeader;
